// layout.js

import React from "react";

import { ThirdwebProvider } from "thirdweb/react";



export const metadata = {
  title: "thirdweb SDK + Next starter",
  description:
    "Starter template for using thirdweb SDK with Next.js App router",
};

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  return (

    <div >
      <ThirdwebProvider>{children}</ThirdwebProvider>
    </div>

  );
}
